<!-- 下拉列表分页组件 -->
<template>
    <el-select @change="choiceValueChange" :remote="remoteStatus" :filterable="filterableStatus" :remote-method="remoteMethod" :value-key="value" ref="selectPage" popper-class="selectPage" v-model="choiceValue" :loading="listLoading" :multiple="isMultiple" :placeholder="placeholder">
            <el-option v-for="(item, index) in list" :key="index+item.code" :label="item[label]" :value="item"></el-option>
        <el-pagination layout="prev, pager, next, jumper" @current-change="handleCurrentPageChange" :current-page="paginationOption.page" :page-size="paginationOption.pagesize" :total="paginationOption.total"></el-pagination>
    </el-select>
</template>

<script>
export default {
    data() {
        return {
            choiceValue: {},
            domSelectTags: []
        }
    },
    props: {
        // 是否启用搜索
        remoteStatus: {
            required: false,
            type: Boolean,
            default: false
        },
        //是否启用搜索
        filterableStatus: {
            required: false,
            type: Boolean,
            default: false
        },
        // 下拉列表数据
        list: {
            required: true,
            type: Array,
            default: []
        },
        // 绑定label的字段名
        label: {
            required: true,
            type: String,
            default: 'label'
        },
        // 绑定value的字段名
        value: {
            required: true,
            type: String,
            default: 'value'
        },
        // 是否多选
        isMultiple: {
            required: true,
            type: Boolean,
            default: false
        },
        placeholder: {
            required: false,
            type: String,
            default: '请选择'
        },
        paginationOption: {
            required: true,
            type: Object,
            default: function() {
                return {
                    pagesize: 5,
                    page: 1,
                    total: 0
                }
            }
        },
        listLoading: {
            required: true,
            type: Boolean,
            default: false
        },
        initData: {
            required: false,
            default: ''
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleCurrentPageChange(page) {
            this.$emit('changePageGetList', page)
        },
        choiceValueChange(value) {
            if (this.isMultiple) {
                this.$emit('getSelectValue', value)
            } else {
                this.$emit('getSelectValue', [value])
            }
        },
        multipleSetTags() {
            this.$nextTick(() => {
                this.domSelectTags = this.$refs.selectPage.$el.getElementsByClassName('el-select__tags-text')
                for(let i = 0; i < this.domSelectTags.length; i++) {
                    if (!this.domSelectTags[i].innerHTML) {
                        this.domSelectTags[i].innerHTML = this.choiceValue[i][this.label]
                    }
                }
            })
        },
        nomultipleSetValue(newV) {
            if (this.choiceValue[this.value] && JSON.stringify(newV).indexOf(this.choiceValue[this.value]) !== -1) {
                this.$nextTick(() => {
                    this.$refs.selectPage.$el.getElementsByClassName('el-input__inner')[0].value = this.choiceValue[this.label]
                })
            }
        },
        remoteMethod(value){
            this.$emit('searchValue', value)
        }
    },
    watch: {
        isMultiple: {
            handler(newV) {
                if (newV) {
                    this.choiceValue = this.initData ? this.initData : []
                } else {
                    this.choiceValue = this.initData ? this.initData : {}
                }
            },
            immediate: true,
            deep: true
        },
        list: {
            handler(newV) {
                if (newV.length) {
                    if (this.isMultiple) {
                        this.multipleSetTags()
                    } else {
                        this.nomultipleSetValue(newV)
                    }
                }
            },
            deep: true
        },
        initData: {
            handler(newV) {
                if (this.isMultiple) {
                    this.choiceValue = newV ? newV : []
                    if (this.choiceValue.length) {
                        this.multipleSetTags()
                    }
                } else {
                    this.choiceValue = this.initData ? this.initData : {}
                    this.nomultipleSetValue(newV)
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .selectPage {
        .el-select-dropdown__list {
            .el-pagination {
                .btn-prev:hover, .btn-next:hover {
                    color: #0B75FA;
                }
                .btn-prev:disabled, .btn-next:disabled {
                    color: #C0C4CC;
                }
                .el-pager {
                    .number.active {
                        color:#0B75FA;
                    }
                    .number:hover {
                        color:#0B75FA;
                    }
                }
            }
        }
    }
</style>